import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import DeviceRestriction from "./components/VisionStudioDeviceRestriction";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <DeviceRestriction />
    <App />
  </React.StrictMode>
);

reportWebVitals();
